"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

require("regenerator-runtime/runtime.js");

var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/maskex-web-exchange/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js"));

var _DBind = _interopRequireDefault(require("../DBind"));

var _DGoogle = _interopRequireDefault(require("../DGoogle"));

var _encryption = _interopRequireDefault(require("@/assets/js/encryption"));

var _message = require("@/components/dialog/message");

var _security = require("@/model/ucenter/security");

var _qrcode = _interopRequireDefault(require("qrcode.vue"));

var _commonMixin = _interopRequireDefault(require("@/components/common/commonMixin.vue"));

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  mixins: [_commonMixin.default],
  components: {
    DBind: _DBind.default,
    DGoogle: _DGoogle.default,
    QrcodeVue: _qrcode.default
  },
  props: ["accountInfo", "emailStatus", "mobileStatus", "googleStatus"],
  data: function data() {
    return {
      secret: "",
      // 谷歌密钥
      gooleLoading: true,
      appDownload: [{
        img: require("./../../../../assets/img/Apple-store.png"),
        apk: require("./../../../../assets/img/Apple-qrCode.png"),
        name: "Apple"
      }, {
        img: require("./../../../../assets/img/Android-market.png"),
        apk: require("./../../../../assets/img/Android-qrCode.png"),
        name: "Android"
      }, {
        img: require("./../../../../assets/img/Google-play.png"),
        apk: require("./../../../../assets/img/Google-qrCode.png"),
        name: "Google"
      }]
    };
  },
  created: function created() {
    this.getGoogleSecret();
  },
  methods: {
    goBack: function goBack() {
      this.$emit("backClick");
    },
    // 复制成功
    copySuccess: function copySuccess() {
      (0, _message.showMessage)({
        message: this.translateTitle("\u5185\u5BB9\u590D\u5236\u6210\u529F"),
        type: "success"
      });
    },
    // 复制失败
    copyError: function copyError() {
      (0, _message.showMessage)({
        message: this.translateTitle("\u5185\u5BB9\u590D\u5236\u5931\u8D25")
      });
    },
    // 获取谷歌验证
    getGoogleSecret: function getGoogleSecret() {
      var _this = this;

      (0, _security.getGoogleSecret)().then(function (res) {
        if (res.status === 200) {
          _this.secret = res.data.secret;
        } else {
          (0, _message.showMessage)({
            message: res.msg
          });
        }
      });
    },
    // 确认提交
    confirmBtn: function confirmBtn() {
      var _this2 = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, emailCheck, mobileCheck, googleCheck, newGoogleCheck, data, _data, _data2, _data3, res, _res;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = {};
                newGoogleCheck = false;
                emailCheck = _this2.$refs.email_ref ? _this2.$refs.email_ref.submitForm() : true;
                mobileCheck = _this2.$refs.mobile_ref ? _this2.$refs.mobile_ref.submitForm() : true;
                googleCheck = _this2.$refs.google_ref ? _this2.$refs.google_ref.submitForm() : true;
                newGoogleCheck = _this2.$refs.new_google_ref ? _this2.$refs.new_google_ref.submitForm() : true;

                if (emailCheck && mobileCheck && googleCheck && newGoogleCheck) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt("return");

              case 8:
                /* 参数 */
                if (_this2.$refs.email_ref) {
                  data = _this2.$refs.email_ref.submitForm();
                  delete data.email;
                  params = Object.assign({}, (0, _objectSpread2.default)({}, data));
                }

                if (_this2.$refs.mobile_ref) {
                  _data = _this2.$refs.mobile_ref.submitForm();
                  delete _data.mobile;
                  params = Object.assign(params, (0, _objectSpread2.default)({}, _data));
                }

                if (_this2.$refs.google_ref) {
                  _data2 = _this2.$refs.google_ref.submitForm();
                  params = Object.assign(params, (0, _objectSpread2.default)({}, _data2));
                }

                if (_this2.$refs.new_google_ref) {
                  _data3 = _this2.$refs.new_google_ref.submitForm();
                  _data3.code = _data3.google_code;
                  delete _data3.google_code;
                  params = Object.assign(params, (0, _objectSpread2.default)({}, _data3));
                }

                params.google_secret = _this2.secret;
                /* 提交请求 */
                // 未绑定谷歌

                if (!(_this2.googleStatus == 0)) {
                  _context.next = 20;
                  break;
                }

                _context.next = 16;
                return (0, _security.bindGoogleVerify)(params);

              case 16:
                res = _context.sent;

                _this2.successType(res, _this2.translateTitle("绑定谷歌验证成功")); // 已绑定谷歌


                _context.next = 26;
                break;

              case 20:
                params["old_google_code"] = params["google_code"];
                params["google_code"] = params["code"];
                _context.next = 24;
                return (0, _security.updateGoogleVerify)(params);

              case 24:
                _res = _context.sent;

                _this2.successType(_res, _this2.translateTitle("修改谷歌验证成功"));

              case 26:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    successType: function successType(res, message) {
      var status = res.status,
          msg = res.msg;

      if (status !== 200) {
        (0, _message.showMessage)({
          message: msg ? msg : status
        });
        return;
      }

      (0, _message.showMessage)({
        message: message,
        type: "success"
      }); // 提交成功

      this.$emit("subSuccess", true);
    }
  },
  watch: {
    googleCode: function googleCode() {
      this.gooleLoading = false;
    }
  },
  computed: {
    emailType: function emailType() {
      return this.googleStatus != 0 ? "21" : "17";
    },
    mobileType: function mobileType() {
      return this.googleStatus != 0 ? "22" : "18";
    },
    btnText: function btnText() {
      return this.googleStatus != 0 ? this.translateTitle("修改验证") : this.translateTitle("开启验证");
    },
    googleCode: function googleCode() {
      var name, $encodeURI;
      var mobileStatus = this.mobileStatus,
          emailStatus = this.emailStatus,
          accountInfo = this.accountInfo,
          secret = this.secret,
          gooleLoading = this.gooleLoading;
      name = (0, _encryption.default)(accountInfo.username);

      if (mobileStatus) {
        name = (0, _encryption.default)(accountInfo.mobile);
      }

      if (emailStatus) {
        name = name ? " " + (0, _encryption.default)(accountInfo.email) : (0, _encryption.default)(accountInfo.email);
      }

      if (secret) {
        var str = secret.slice(secret.length - 6);
        var val = "otpauth://totp/".concat(this.projectEnglishName, "(").concat(name, "-").concat(str, ")?secret=").concat(secret);
        val = val.replace(/\s+/g, "");
        return val;
      } else {
        return "";
      }
    }
  }
};
exports.default = _default;